/* eslint-disable eqeqeq */
import * as React from "react";
import Box from "@mui/material/Box";
import { Formik } from "formik";
import { useEffect } from "react";
import Styles from "./Update.module.scss";
import { useDispatch } from "react-redux";
import { Form } from "react-bootstrap";
import { useState } from "react";
import axios from "axios";
import { updateDispatch } from "../../redux/admin/actions/admin.actions";
import { trackOptions } from "../../data";
import { SelectField } from "../../components/Form/SelectField";

export default function CreateForm(props) {
  const dispatch = useDispatch();

  const baseUrl = "https://lab.lifebank.ng/labx/api/v1/auth/user/state/Nigeria";

  const [stateOptionDropDown, setstateOptionDropDown] = useState();
  const [selectedState, setSelectedState] = useState();
  const [track, setTrack] = useState();

  useEffect(() => {
    const fetchData = () => {
      axios.get(baseUrl).then((response) => {
        let options = response?.data?.states
          .sort((a, b) => (a?.name > b.name ? -1 : 1))
          .map((state) => ({
            label: state.name,
            value: state.name,
          }));
        setstateOptionDropDown(options);
      });
    };
    fetchData();
  }, []);

  useEffect(() => {
    let options = trackOptions?.map((t) => ({
      label: t?.label,
      value: t?.value,
    }));
    setTrack(options);
  }, []);

  return (
    <>
      <Formik
        initialValues={{
          first_name: "",
          last_name: "",
          phone_number: "",
          State: "",
          bike_id: props.bike_id,
          id: props.id,
          tracker: "",
        }}
        validate={(values) => {
          const errors = {};
          if (!values.first_name) {
            errors.first_name = "This field is required";
          }
          if (!values.last_name) {
            errors.last_name = "This field is required";
          }

          if (!values.phone_number){
            errors.phone_number = "This field is required"
          }

          if (!values.bike_id) {
            errors.bike_id = "This field is required";
          }

          if (!values.tracker) {
            errors.tracker = "This field is required";
          }

          return errors;
        }}
        onSubmit={(values) => {
          const findSelectedStateLabel = stateOptionDropDown.filter(
            (state) => state.value == selectedState
          );

          values.State = findSelectedStateLabel[0].label;
          values.tracker = values.tracker.value;
          // console.log(values);
          dispatch(updateDispatch(values));
          props.onClickYes();
        }}
      >
        {({
          handleChange,
          handleSubmit,
          isSubmitting,
          values,
          event,
          resetForm,
          setFieldValue,
          handleBlur,
          errors,
          touched,
        }) => (
          <>
            <Box
              component='form'
              sx={{
                "& .MuiTextField-root": { m: 1, minWidth: "50ch" },
              }}
              noValidate
              autoComplete='off'
            >
              <>
                <div className='d-flex flex-column mt-3'>
                  <p className={Styles.label}>First Name</p>
                </div>
                <div>
                  <Form.Control
                    type='text'
                    onChange={handleChange}
                    name='first_name'
                    placeholder={props.first_name}
                    // style={{ height: "100px" }}
                  />
                </div>
                {errors.first_name && touched.first_name ? (
                  <p className='text-danger mt-1 mx-2'>{errors.first_name}</p>
                ) : null}
              </>

              <>
                <div className='d-flex flex-column mt-3'>
                  <p className={Styles.label}>Last Name</p>
                </div>
                <div>
                  <Form.Control
                    type='text'
                    onChange={handleChange}
                    name='last_name'
                    placeholder={props.last_name}
                    // style={{ height: "100px" }}
                  />
                </div>
                {errors.last_name && touched.last_name ? (
                  <p className='text-danger mt-1 mx-2'>{errors.last_name}</p>
                ) : null}
              </>

              <>
                <div className='d-flex flex-column mt-3'>
                  <p className={Styles.label}>Phone Number</p>
                </div>
                <div>
                  <Form.Control
                    type='tel'
                    onChange={handleChange}
                    name='phone_number'
                    placeholder={props.phone_number}
                    // style={{ height: "100px" }}
                  />
                </div>
                {errors.last_name && touched.last_name ? (
                  <p className='text-danger mt-1 mx-2'>{errors.last_name}</p>
                ) : null}
              </>

              <>
                <div className='d-flex flex-column mt-3'>
                  <p className={Styles.label}>Location</p>
                </div>
                <div>
                  <select
                    className={`${Styles.formInput} shadow-none form-control`}
                    placeholder='Location'
                    name='State'
                    // onChange={(option) => loadStateLGAOption(option)}
                    values={values.State}
                    onChange={(e) => {
                      const selectedStateId = e.currentTarget.value;
                      setSelectedState(selectedStateId);
                    }}
                    required
                  >
                    <option>Select State</option>
                    {stateOptionDropDown
                      ?.sort((a, b) => (a?.label > b?.label ? 1 : -1))
                      ?.map((stateOption) => {
                        return (
                          <option
                            value={stateOption?.value}
                            label={stateOption?.label}
                            key={stateOption?.value}
                          >
                            {stateOption?.label}
                          </option>
                        );
                      })}
                  </select>
                </div>
              </>

              <>
                <div className='d-flex flex-column mt-3'>
                  <p className={Styles.label}>Bike ID</p>
                </div>
                <div>
                  <Form.Control
                    type='text'
                    onChange={handleChange}
                    name='bike_id'
                    placeholder={props.bike_id}
                    // style={{ height: "100px" }}
                  />
                </div>
                {errors.bike_id && touched.bike_id ? (
                  <p className='text-danger mt-1 mx-2'>{errors.bike_id}</p>
                ) : null}
              </>

              <>
                <div className='d-flex flex-column mt-3'>
                  <p className={Styles.label}>Tracking Option</p>
                </div>
                <div>
                  <SelectField
                    name='tracker'
                    options={track}
                    onChange={setFieldValue}
                    placeholder='Select a tracking option'
                    onBlur={handleBlur}
                  />
                </div>
                {errors.tracker && touched.tracker ? (
                  <p className='text-danger mt-1 mx-2'>{errors.tracker}</p>
                ) : null}
              </>

              <div className='d-flex justify-content-center mt-3'>
                <button
                  type='submit'
                  className={` shadow-none ${Styles.actionBtn} ${Styles.confirm} `}
                  style={{ background: props.btnColor }}
                  onClick={() => props.onClickNo()}
                >
                  Cancel
                </button>

                <button
                  type='submit'
                  className={` shadow-none  ${Styles.actionBtn} ${Styles.reject}`}
                  style={{ background: props.btnColor }}
                  onClick={handleSubmit}
                >
                  Update
                </button>
              </div>
            </Box>
          </>
        )}
      </Formik>
    </>
  );
}
